import { render } from "./CertificadoView.vue?vue&type=template&id=b3f7a148"
import script from "./CertificadoView.vue?vue&type=script&lang=js"
export * from "./CertificadoView.vue?vue&type=script&lang=js"

import "./CertificadoView.vue?vue&type=style&index=0&id=b3f7a148&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__